/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const PendingInviteAPI = {
  fetchTeamPendingInvites: async (team_id: any, is_pending: boolean) =>
    (await initAxios())
      ?.post('/pending/team', JSON.stringify({ team_id: team_id, is_pending: is_pending }))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  hasPendingTeamInvite: async (team_id: any, email: string) =>
    (await initAxios())
      ?.post('/pending/teamInvite', JSON.stringify({ team_id: team_id, email: email }))
      .then((resp) => {
        return {
          success: resp.status === 200 && resp.data,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  removePendingInvite: async (team_id: any, email: string) =>
    (await initAxios())
      ?.post('/pending/remove', JSON.stringify({ team_id: team_id, email: email }))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  addPendingInvite: async (
    team_id: any,
    email: string,
    preassigned_license_type = 'none',
  ) =>
    (await initAxios())
      ?.post(
        '/pending/add',
        JSON.stringify({
          team_id: team_id,
          email: email,
          preassigned_license_type: preassigned_license_type,
        }),
      )
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default PendingInviteAPI;
